import { render, staticRenderFns } from "./InputItemTable.vue?vue&type=template&id=8b6bb8a6&"
import script from "./InputItemTable.vue?vue&type=script&lang=js&"
export * from "./InputItemTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports